import i18n from 'i18n/config';

const beneficiaryStatus = {
  var: {
    CONSOLIDATED: 'CONSOLIDATED',
    ACTIVE: 'ACTIVE',
    CANCELED: 'CANCELED',
    DRAFT: 'DRAFT',
    PAUSED: 'PAUSED',
  },
  name: {
    CONSOLIDATED: i18n.t('Consolidated'),
    ACTIVE: i18n.t('Active'),
    CANCELED: i18n.t('Canceled'),
    DRAFT: i18n.t('BeneficiariesDraft'),
    PAUSED: i18n.t('Paused'),
  },
  style: {
    CONSOLIDATED: 'success',
    ACTIVE: 'warning',
    CANCELED: 'danger',
    DRAFT: 'info',
    PAUSED: 'gray',
  },
};

export default beneficiaryStatus;
